import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type StudentProgress = {
  studentId: string;
  studentName: string;
  students: string;
  videosWatched: number;
  totalVideos: number;
  percentage: number;
};

type StudentsResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: StudentProgress;
};
export const StudentCourseProgress = async (
  id: string
): Promise<StudentsResponse> => {
  try {
    const response = await axios.get(
      `/admin/getStudentsForOneCourse/${id}`
    );
    
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
